"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var event_bus_1 = require("@idp/event-bus");
var Events = /** @class */ (function () {
    function Events(serviceNames) {
        this.observableId = event_bus_1.ICCEventBusManager.getUUID();
        var currentObservee = {
            observerableId: this.observableId,
            serviceNames: serviceNames,
        };
        event_bus_1.ICCEventBusManager.getInstance().configObserverable(currentObservee);
    }
    Events.prototype.fireEvent = function (data, serviceName) {
        event_bus_1.ICCEventBusManager.getInstance().notifyObservers(this.observableId, serviceName, data);
    };
    return Events;
}());
exports.default = Events;
//# sourceMappingURL=Events.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/api/Events.js
// module id = 156
// module chunks = 8